var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"light","placement":_vm.placement},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._v(" "+_vm._s(_vm.content))]},proxy:true}])},[_vm._t("default",function(){return [_c('i',{class:_vm.iconClass,style:(_vm.styles)})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }